import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ArticleCard = makeShortcode("ArticleCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Row mdxType="Row">
  <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
  <ArticleCard subTitle="" title="Artificial Intelligence" color="dark" actionIcon="arrowRight" href="/guides/ai" mdxType="ArticleCard">
          <p>{`  `}<span parentName="p" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "928px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "56.25%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAIAAADwazoUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAArUlEQVQoz5XSTwuCMBgGcL//R+kcCcFIli7bEqUgw1OnTjb/MFtzboVFIaapL2On97fn8Mx4DI3W9ekcYxD0yV7cZDdWsUx2vtLG7wUutBPcrWVy3ucQpAGko7BS9W0d5AzwI8nsbYFwkcdiFK5eeE7KXSTJitoeX5hp6CYTklEogSegeXVwsd6MTv7m+yeBUXaJmAtT36ITcLMtpbQs9ZSeP/jPDxnouVX47zwBTYeEZAh6nP4AAAAASUVORK5CYII=')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "Learn about AI",
                "title": "Learn about AI",
                "src": "/static/bfeaa91c2516851a1afc2548c63eb02f/39971/ai.png",
                "srcSet": ["/static/bfeaa91c2516851a1afc2548c63eb02f/7fc1e/ai.png 288w", "/static/bfeaa91c2516851a1afc2548c63eb02f/a5df1/ai.png 576w", "/static/bfeaa91c2516851a1afc2548c63eb02f/39971/ai.png 928w"],
                "sizes": "(max-width: 928px) 100vw, 928px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy"
              }}></img>{`
    `}</span></p>
  </ArticleCard>
  </Column>
  <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
  <ArticleCard subTitle="" title="APIs" color="dark" actionIcon="arrowRight" href="/guides/apis" mdxType="ArticleCard">
          <p>{`  `}<span parentName="p" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "928px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "56.25%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAIAAADwazoUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAkklEQVQoz2P4TwFgwCP3D4kkQfO/f1BN//6RbjNQz+/f//78+ffr17+fv/79/vWXKM1/wcrO3fmze+u7Pce+nTr4fs+Bz3euf8XqCnTNf8Cad53/vXT28yWbPp898uHSha8vX/4mSvNfsIpbz/9eu/D5wvUfv//9P3D8650rX4jSjCvkSAuwfyBAIMAZaJVICAIAtMSJXNtDTUEAAAAASUVORK5CYII=')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "Learn about AI",
                "title": "Learn about AI",
                "src": "/static/da57441eb0c0cfb421e21e21d7da2669/39971/api.png",
                "srcSet": ["/static/da57441eb0c0cfb421e21e21d7da2669/7fc1e/api.png 288w", "/static/da57441eb0c0cfb421e21e21d7da2669/a5df1/api.png 576w", "/static/da57441eb0c0cfb421e21e21d7da2669/39971/api.png 928w"],
                "sizes": "(max-width: 928px) 100vw, 928px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy"
              }}></img>{`
    `}</span></p>
  </ArticleCard>
  </Column>
  <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
  <ArticleCard subTitle="" title="Big data" color="dark" actionIcon="arrowRight" href="/guides/big-data" mdxType="ArticleCard">
          <p>{`  `}<span parentName="p" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "928px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "56.25%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAIAAADwazoUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAu0lEQVQoz6WSTwuCQBDF/f5foVuHLuUhkC6Z5SWwOkgZIYkQC4HiX9BdFmfdWoQKWkvrsQzD7vyYB/sU/oeUtoe6fp5+8IMRDW/lFSl5V5iAZhQrPUM+Fpes/g43M0fEBlq53GDXKWfDK3JyLtv/BjNR1y6oJllY+LQvzGnob1OpczlseTA2iIcqikGfBBc762a7gc8wmhPTwge7MNTA36WdbDeiFQ9TFiUQx1UeUUqg3z//HpLXhHzIyQ3syYPp0GAfvAAAAABJRU5ErkJggg==')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "Learn about containers",
                "title": "Learn about containers",
                "src": "/static/de48c0218b0c6ba24c6ee74f7cf762e5/39971/big-data.png",
                "srcSet": ["/static/de48c0218b0c6ba24c6ee74f7cf762e5/7fc1e/big-data.png 288w", "/static/de48c0218b0c6ba24c6ee74f7cf762e5/a5df1/big-data.png 576w", "/static/de48c0218b0c6ba24c6ee74f7cf762e5/39971/big-data.png 928w"],
                "sizes": "(max-width: 928px) 100vw, 928px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy"
              }}></img>{`
    `}</span></p>
  </ArticleCard>
  </Column>
  <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
  <ArticleCard subTitle="" title="Containers" color="dark" actionIcon="arrowRight" href="/guides/containers" mdxType="ArticleCard">
          <p>{`  `}<span parentName="p" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "928px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "56.25%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAIAAADwazoUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAq0lEQVQoz2P4TwFgwCr67x8IwRkQNrGageDvPxAizWaIJa8+/ltz+OeJc9+uPvyzafOHNw++gqX+EaX5wau/K47+2nbo68Ez33ft+/T2yTe4FGHNT9/+XXjg15z1n7etenX/9PuvH36RoPn+q79rT/zecujbwZ1vL+589ezmZ5DUX+Kc/f7rvx2nf548/+3C2c9Xjr77/PonUTajxNZ/fPFEOJ7BHNLjmRgAAO8ZhMjBVgVNAAAAAElFTkSuQmCC')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "Learn about containers",
                "title": "Learn about containers",
                "src": "/static/f0d44e0694e28bc1711c2ab3f504d6cb/39971/containers.png",
                "srcSet": ["/static/f0d44e0694e28bc1711c2ab3f504d6cb/7fc1e/containers.png 288w", "/static/f0d44e0694e28bc1711c2ab3f504d6cb/a5df1/containers.png 576w", "/static/f0d44e0694e28bc1711c2ab3f504d6cb/39971/containers.png 928w"],
                "sizes": "(max-width: 928px) 100vw, 928px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy"
              }}></img>{`
    `}</span></p>
  </ArticleCard>
  </Column>
  <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
  <ArticleCard subTitle="" title="Databases" color="dark" actionIcon="arrowRight" href="/guides/databases" mdxType="ArticleCard">
          <p>{`  `}<span parentName="p" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "928px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "56.25%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAIAAADwazoUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAApElEQVQoz7WSywrCMBBF+/9/orhTdKOIVqSQFp8I4kKrCApRREuSmSQTA4LdWCSIl1nO4QzciVxFiMqpSuR+yAf4ZRJA/GauF5SFCTNbcp0UYyY3azHvcRQmAEbjakNIJnK/U6x5knddnvQV1tY1RjDORL5VWfusHiGwN9djYDN5PEDaCjT7te4U+4lYLYrlgGtlw6ry9WpDCGQNBff8/o1/PckT+AiHOVf1N8wAAAAASUVORK5CYII=')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "Learn about databases",
                "title": "Learn about databases",
                "src": "/static/93ca8c34aa069488617eda478eef35bd/39971/databases.png",
                "srcSet": ["/static/93ca8c34aa069488617eda478eef35bd/7fc1e/databases.png 288w", "/static/93ca8c34aa069488617eda478eef35bd/a5df1/databases.png 576w", "/static/93ca8c34aa069488617eda478eef35bd/39971/databases.png 928w"],
                "sizes": "(max-width: 928px) 100vw, 928px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy"
              }}></img>{`
    `}</span></p>
  </ArticleCard>
  </Column>
  <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
  <ArticleCard subTitle="" title="Development practices" color="dark" actionIcon="arrowRight" href="/guides/teaming" mdxType="ArticleCard">
          <p>{`  `}<span parentName="p" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "928px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "56.25%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAIAAADwazoUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAr0lEQVQoz2P4TwFgwCXx7x8M/SVRM1APEPz5+w+IwNx/xGqGqNx94vvGPV+O7X9/bMcbuCABzRBFT9783Xrix9HTX0+f/HRu/9vXD79h1Y+u+Q/Yh1tP/1p39OeCZW/nznl1+eDb89tfAQX//v1HlM3vPv9bvf/78bPfLp//cnTL64+vfxJlM1zRqas/dxz6evLwh0snPhDrZ2T9kKjCpRNfPP/9C9X89y/piYQYAACvroSmybPpWgAAAABJRU5ErkJggg==')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "Learn about databases",
                "title": "Learn about databases",
                "src": "/static/2006870de957c8444c43be5a65a19966/39971/teaming.png",
                "srcSet": ["/static/2006870de957c8444c43be5a65a19966/7fc1e/teaming.png 288w", "/static/2006870de957c8444c43be5a65a19966/a5df1/teaming.png 576w", "/static/2006870de957c8444c43be5a65a19966/39971/teaming.png 928w"],
                "sizes": "(max-width: 928px) 100vw, 928px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy"
              }}></img>{`
    `}</span></p>
  </ArticleCard>
  </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      